import PropTypes from 'prop-types';
import { FormControlLabel, InputAdornment, Radio, RadioGroup, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Search from '@material-ui/icons/Search';
import Tooltip from '@material-ui/core/Tooltip';
import { LegacyIcon } from '../../../../../icon';
import { VOIP_ADAPTER_TYPE_WIRELESS } from '../../../ServiceTestsConstants';
import { useNoPaddingLeftStyles } from '../../../../../form/FormStyles';
import TestSubFormSection from '../TestFormSection/TestSubFormSection';

function VoipAgentFormSection(props) {
    const noPaddingLeftStyles = useNoPaddingLeftStyles();

    return <TestSubFormSection fieldsClassName={noPaddingLeftStyles.ngpFormFields} {...props} />;
}

export default function VoipAgentListPanel({
    title,
    agents,
    filterText,
    onFilterChange,
    selectedId,
    onSelect,
    classes,
}) {
    return (
        <VoipAgentFormSection title={title}>
            <div className={classes.filterContainer}>
                <TextField
                    placeholder="Filter nPoints"
                    size="small"
                    value={filterText}
                    onChange={(e) => onFilterChange(e.target.value)}
                    fullWidth
                    InputProps={{
                        disableUnderline: true,
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search style={{ fontSize: '18px' }} />
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
            <div className={classes.filterCount}>
                <span className={classes.filterLength}>{`${agents.length}`}</span>
                {` filtered nPoints`}
            </div>
            <Paper
                style={{
                    width: '100%',
                    height: 230,
                    overflow: 'auto',
                    border: '1px solid rgba(0, 0, 0, 0.12)',
                }}
            >
                <RadioGroup value={selectedId} onChange={onSelect}>
                    {agents.map((agent) => (
                        <Tooltip key={agent.id} title={agent.interfaceTooltip || ''} arrow>
                            <FormControlLabel
                                value={agent.id}
                                label={
                                    <span className={classes.agentLabel}>
                                        <LegacyIcon icon={agent.typeIcon} />
                                        <span>{agent.name}</span>
                                        {agent.adapterType === VOIP_ADAPTER_TYPE_WIRELESS && (
                                            <span>({agent.interfaceName} Interface)</span>
                                        )}
                                    </span>
                                }
                                control={<Radio className={classes.agentRadio} />}
                                className={classes.agentListItem}
                            />
                        </Tooltip>
                    ))}
                </RadioGroup>
            </Paper>
        </VoipAgentFormSection>
    );
}

VoipAgentListPanel.propTypes = {
    title: PropTypes.node.isRequired,
    agents: PropTypes.array.isRequired,
    filterText: PropTypes.string.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    selectedId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

VoipAgentListPanel.defaultProps = {
    selectedId: '',
};
